import convertToKebabCase from '../convertToKebabCase'

export default function getDataSelector(prefix?: string, value?: string): string | undefined {
  if (!prefix) return

  if (!value) return convertToKebabCase(prefix)

  return `${convertToKebabCase(prefix)}-${convertToKebabCase(value)}`
}
